import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';
import i18n from "translations";

import { Creators as AuthActions, Types as AuthTypes } from 'store/ducks/auth';

function* loginRequest(action) {
  try {
    const { credentials } = action.payload;
    const url = 'auth/users/login';
    const response = yield call(api.post, url, credentials);

    localStorage.setItem('auth_token', response.data.jwt);

    yield call(getAuthUserRequest);
    yield put(push('/admin/dashboard'));
    yield put(AuthActions.loginSuccess());
  } catch (error) {
    if (error.response.data && error.response.data.error && error.response.data.error === 'invalid password') {
      yield call(swal, 'Falha ao conectar', 'Usuário ou senha inválidos', 'error');
    } else {
      yield call(swal, 'Falha ao conectar', 'Não foi possível autenticar o seu usuário', 'error');
    }

    yield put(AuthActions.loginFailure());
  }
}

function* getAuthUserRequest(action) {
  try {
    const url = 'prte_person/people/me';
    const response = yield call(api.get, url);

    const { data } = response.data;

    i18n.changeLanguage(data.attributes.locale);
    // i18n.changeLanguage("en");

    yield put(AuthActions.getAuthUserSuccess(response.data));
  } catch (error) {
    yield call(logoutRequest);
    yield put(AuthActions.getAuthUserFailure());
  }
}

function* logoutRequest(action) {
  try {
    localStorage.removeItem('auth_token');

    yield put(push('/login'));
    yield put(AuthActions.logoutSuccess());
  } catch (error) {
    yield put(AuthActions.logoutFailure());
  }
}

function* registerRequest(action) {
  try {
    const url = 'register';
    yield call(api.post, url, action.payload.data);

    yield put(push('/login'));
    yield call(swal, 'Registro Concluído', 'Parabéns, seu registro foi concluído com sucesso.', 'success');
    yield put(AuthActions.registerSuccess());
  } catch (error) {
    yield call(
      swal,
      'Ops, algo deu errado',
      'Não foi possível concluir seu registo, tente novamente mais tarde.',
      'error',
    );
    yield put(AuthActions.registerFailure());
  }
}

function* recoverPasswordRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'auth/users/password/forgot';
    yield call(api.post, url, data);

    yield put(push('/login'));
    yield call(
      swal,
      'Solicitação Enviada',
      'Uma confirmação de troca de senha foi enviada para o seu e-mail.',
      'success',
    );
    yield put(AuthActions.recoverPasswordSuccess());
  } catch (error) {
    yield call(
      swal,
      'Ops, algo deu errado',
      'Não foi possível solicitar a recuperação de senha, tente novamente mais tarde.',
      'error',
    );
    yield put(AuthActions.recoverPasswordFailure());
  }
}

export default function* sagaAuth() {
  yield takeLatest(AuthTypes.LOGIN_REQUEST, loginRequest);
  yield takeLatest(AuthTypes.LOGOUT_REQUEST, logoutRequest);
  yield takeLatest(AuthTypes.GET_USER_REQUEST, getAuthUserRequest);
  yield takeLatest(AuthTypes.REGISTER_REQUEST, registerRequest);
  yield takeLatest(AuthTypes.RECOVER_PASSWORD_REQUEST, recoverPasswordRequest);
}



// WEBPACK FOOTER //
// ./src/store/sagas/auth.js